import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    edit: translate({ id: 'settings.rmAccount.view.edit' }),
    changePassword: translate({ id: 'settings.rmAccount.view.changePassword' }),
  }))

  return api
}
